export default __webpack_public_path__ + "static/media/Icons_Email_Blue Sent Icon.b063a454.svg";